export const LightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5rem"
      height="1.5rem"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16 0C7.168 0 0 7.168 0 16C0 24.832 7.168 32 16 32C24.832 32 32 24.832 32 16C32 7.168 24.832 0 16 0ZM16 27.2C14.672 27.2 13.6 26.128 13.6 24.8H18.4C18.4 26.128 17.328 27.2 16 27.2ZM20.8 23.2H11.2V20.8H20.8V23.2ZM20.752 19.2H11.248C9.28 17.744 8 15.424 8 12.8C8 8.384 11.584 4.8 16 4.8C20.416 4.8 24 8.384 24 12.8C24 15.424 22.72 17.744 20.752 19.2Z"
        fill="#355968"
      />
    </svg>
  )
}
